import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// 🌍 Dil normalizasyon fonksiyonu (`tr-TR` → `tr`, `en-US` → `en`)
const normalizeLang = (lng) => {
  if (!lng) return 'en'; // Varsayılan olarak 'en' kullan
  return lng.split('-')[0]; // `tr-TR` → `tr`
};

// 🔍 **Language Detector'ı manuel olarak override edelim**
const CustomLanguageDetector = {
  type: 'languageDetector',
  detect: () => {
    let userLangs = navigator.languages
      ? navigator.languages.map(normalizeLang) // `tr-TR` → `tr`
      : [normalizeLang(navigator.language)];

    console.log("🌍 Algılanan Diller (Normalize Edildi):", userLangs);

    // 🚨 **Sadece desteklenen diller arasından seçim yap**
    const detected = userLangs.find(lng => i18n.options.supportedLngs.includes(lng)) || 'en';
    console.log(`[i18next] ✅ Kullanılacak Dil: ${detected}`);
    return detected;
  },
  init: () => {},
  cacheUserLanguage: () => {},
};

i18n
  .use(HttpApi)
  .use(CustomLanguageDetector) // ✅ **Manuel LanguageDetector kullanıyoruz**
  .use(initReactI18next)
  .init({
    supportedLngs: ['tr', 'it', 'es','en','ar','fr','de'], // ✅ SADECE BU DİLLERİ DESTEKLİYORUZ
    fallbackLng: 'en', // ✅ Varsayılan olarak İngilizce'ye git
    debug: true,

    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },

    detection: {
      order: [], // ❌ Varsayılan detection'ı kapatıyoruz, çünkü artık Custom Detector kullanıyoruz
      caches: [], // ❌ Tarayıcıya kayıt yapmayı kapatıyoruz
    },

    interpolation: {
      escapeValue: false,
    },
  });

// 🌍 Dil değiştirildiğinde log yaz
i18n.on('languageChanged', (lng) => {
  console.log(`[i18next] 🔄 Dil Değiştirildi: ${lng}`);
});

// 🌍 `i18next` başlatıldığında log yaz
i18n.on('initialized', () => {
  console.log(`[i18next] 🚀 i18next Başlatıldı. Algılanan Dil: ${i18n.language}`);
});

export default i18n;
